<template>
  <router-link to="/valentinstag" class="valentine is-block has-background-primary">
    <div class="columns  is-multiline is-vcentered" v-if="$whitelabel.short.toLowerCase() === 'adac'">
      <div class="column is-6-tablet is-5-desktop is-7-widescreen valentine__content valentine__content--adac mt-3">
        <div class="has-text-centered-mobile valentine__text--adac">
          <div
            class="title is-inline-block is-size-3-mobile is-size-2-tablet is-size-1-widescreen has-text-weight-bold u-p05 has-text-black px-0 valentine__headline--adac">
            <!-- <p class="has-background-secondary is-size-5 is-size-3-tablet is-size-2-fullhd is-inline-block has-text-weight-bold has-text-white pr-1 pl-1 mb-3">
              ADAC Hotelgutschein
            </p> -->

            <p>Angebote zum Verlieben!</p>
          </div>
          <p class=" has-text-black is-size-6 is-size-5-tablet is-size-5-desktop is-size-4-widescreen is-size-3-fullhd has-text-weight-bold"
            style="line-height: 1.2">Ausgewählte Kurzurlaube <br />für Ihre romantische Auszeit</p>

          <b-button tag="router-link" to="/valentinstag" type="is-light" class="mt-5">
            Hier klicken & kaufen!
          </b-button>
        </div>
      </div>
      <div class="column is-6-tablet is-7-desktop is-5-widescreen pt-5 pb-5 valentine__img--adac">
        <p class=" has-text-centered has-text-right-desktop">
          <img fetchpriority="high"
            :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=700&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/valentinstag.png`"
            alt="Valentinstag" width="700" height="344" />
        </p>
      </div>
    </div>

    <!-- <div class="columns" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
      <div class="column is-6 has-text-centered">
        <img
          fetchpriority="high"
          :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/valentine.png`"
          :srcset="
            `https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/valentine.png 500w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=370&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/valentine.png 370w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=280&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/valentine.png 280w`
          "
          sizes="(max-width: 500px) 100vw, 400px"
          alt="Black Friday Week"
          width="400"
          height="300"
        />
      </div>
      <div class="column valentine__content">
        <div class="has-text-centered-mobile">
          <p class="title has-background-white has-text-black is-inline-block is-size-6 is-size-3-tablet has-text-weight-bold is-uppercase u-pl15 u-pr15 u-p05">Black Friday Week</p>
          <p class=" has-text-white is-size-6 is-size-5-tablet has-text-weight-normal">21. November - 29. November</p>

          <b-button tag="router-link" to="/blackfriday" type="is-dark" inverted outlined class="mt-5 mb-5">
            Zu den Angeboten
          </b-button>
        </div>
      </div>
    </div> -->
  </router-link>
</template>

<script>
export default {
  name: 'Valentine',

  props: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.valentine {
  //background-color: red;

  .title {
    margin-bottom: 0.75rem;
  }
}

.valentine__text--adac {
  padding-left: 1rem;
  padding-right: 1rem;
}

@media screen and (min-width: 769px) {
  .valentine__text--adac {
    margin-bottom: 1rem;
    margin-left: 1rem;
    margin-right: 0;
  }

  .valentine__content {
    margin-top: 3rem;
  }
}

@media screen and (min-width: 1024px) {
  .valentine__text--adac {
    margin-bottom: 2rem;
    margin-left: 2rem;
  }

  .valentine__img--adac {
    padding-right: 3rem;
  }
}

@media screen and (min-width: 1418px) {
  .valentine__headline--adac {
    font-size: 3.6rem !important;
  }
}
</style>
